export enum PatchGroupClasificationEnum {
    CRITUPD = 'CritUpd', //Critical Update Only
    CRITSECUPD = 'CritSecUpd',//Critical Security Update
    ALLUPD = 'AllUdp' //All Updates
  }
